/**
 * TenantMapPage — SAAS-TENANT-PORTAL-MAP-1.
 *
 * Página "Mapa" do portal do cliente (tenant_owner/tenant_admin/viewer). Mostra
 * os dispositivos do PRÓPRIO tenant no mapa. Reaproveita o DeviceMapPanel SEM
 * `tenantId` → o backend escopa por ctx.tenant_id (o request não manda tenant_id;
 * nunca X-Tenant), então cada tenant só vê a própria frota. super_admin, que
 * também enxerga este item, vê a frota global (mesma semântica de Dispositivos).
 */
import DeviceMapPanel from "../components/tenants/DeviceMapPanel.jsx";

export default function TenantMapPage({ onNavigate }) {
  return (
    <div className="space-y-4">
      <div className="flex items-start gap-3 flex-wrap">
        <div className="flex-1 min-w-[12rem]">
          <h1 className="text-2xl font-bold tracking-tight">Mapa dos dispositivos</h1>
          <p className="text-xs text-noc-muted">
            Localização e status dos equipamentos da sua empresa.
          </p>
        </div>
        {/* SAAS-COMPANIES-P2-PORTAL-POLISH — CTAs de navegação do portal */}
        <div className="flex gap-2">
          <button type="button" onClick={() => onNavigate?.("devices")}
            className="h-8 px-3 rounded-lg text-xs border border-noc-border text-noc-text">
            Ver dispositivos
          </button>
          <button type="button" onClick={() => onNavigate?.("claim-device")}
            className="h-8 px-3 rounded-lg text-xs font-semibold bg-noc-accent/15 text-noc-accent border border-noc-accent/40">
            + Adicionar dispositivo
          </button>
        </div>
      </div>
      <DeviceMapPanel onNavigate={onNavigate} />
    </div>
  );
}
